/**
 * checks for unsaved fields in population rules page and prompts for confirmation to navigate away
 */


import {PopulationRulesComponent} from "./population-rules.component";
import {Injectable} from "@angular/core";

declare var $: any;

@Injectable()

export class ConfirmDeactivateGuard  {

  canDeactivate(target: PopulationRulesComponent) {
    return target.hasChanges();
  }

}
